import { NavigateOptions, useLocation, useNavigate } from "react-router-dom";

/**
 * use Query URL
 * @returns
 */
export default function useQueryURL() {
  const location: string = useLocation().search;
  const navigate = useNavigate();
  const getQueryValue = (queryKey: string) => {
    const urlParams = new URLSearchParams(location);
    return urlParams.get(queryKey);
  };
  const setQueryValue = (list: { [key: string]: string }, navigateOptions?: NavigateOptions ) => {
    const urlParams = new URLSearchParams(location);
    for (const [key, value] of Object.entries(list)) {
      urlParams.set(key, value);
    }
    const path = location.split("?")[0] + "?" + urlParams.toString();
    navigate(path, navigateOptions || { replace: true });
  };
  const removeQueryValue = (queryKey: string[], navigateOptions?: NavigateOptions) => {
    const urlParams = new URLSearchParams(location);
    queryKey.forEach((key) => urlParams.delete(key));
    const path = location.split("?")[0] + "?" + urlParams.toString();
    navigate(path, navigateOptions || { replace: true });
  };

  
  return {
    getQueryValue,
    setQueryValue,
    removeQueryValue,
    currentLocation: location,
  };
}
